import { jsx } from 'react/jsx-runtime';
import { SSRProvider as SSRProvider$1 } from 'react-aria';
import { ModalContextController } from '../base/modal/context/ModalContextController.js';
import { ToastContextController } from '../base/toast/context/ToastContextController.js';

var Provider = function (_a) {
    var children = _a.children;
    return (jsx(ModalContextController, { children: jsx(ToastContextController, { children: children }) }));
};
var SSRProvider = SSRProvider$1;

export { Provider, SSRProvider };
